module.exports = __webpack_public_path__ + "static/media/lettering-sign2.33ce5aac.jpg";